import React from 'react';
import styled from 'styled-components';
import Button from '../common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlock } from '@fortawesome/free-solid-svg-icons';

const BannerWrapper = styled.div`
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
  color: white;
  padding: 30px 40px;
  border-radius: ${({ theme }) => theme.radii.md};
  margin: 40px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  box-shadow: ${({ theme }) => theme.shadows.lg};

  @media(max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    text-align: center;
  }
`;

const BannerContent = styled.div`
  h3 {
    font-size: 22px;
    margin-bottom: 10px;
  }
  p {
    opacity: 0.9;
    font-size: 16px;
  }
`;

const UpsellButton = styled(Button)`
  background: white;
  color: ${({ theme }) => theme.colors.primary};
  flex-shrink: 0;

  &:hover {
    background: white;
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

const UpsellBanner = ({ onClick }) => (
  <BannerWrapper>
    <BannerContent>
      <h3>Quer ver todas as informações completas?</h3>
      <p>Desbloqueie o relatório com todos os detalhes do veículo incluindo histórico, gravames e muito mais.</p>
    </BannerContent>
    <UpsellButton onClick={onClick}>
      <FontAwesomeIcon icon={faUnlock} /> Desbloquear Relatório Completo
    </UpsellButton>
  </BannerWrapper>
);

export default UpsellBanner;